module.exports = __webpack_public_path__ + "static/img/bg.dac3d92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/DiscountAgentInvite/PC/bg.png
// module id = c4N0
// module chunks = 70